import { ComponentProductDto } from '~/modules/Products/Infrastructure/Dtos/ComponentProductDto'
import {
  RenderComponentStrategyInterface
} from '~/modules/Products/Infrastructure/RenderComponentStrategies/RenderComponentStrategyInterface'
import { ReactElement } from 'react'
import { MemoryAddableTrophyCard } from '~/components/MemoryAddableTrophyCard'
import { ComponentTrophyDto } from '~/modules/Products/Infrastructure/Dtos/ComponentTrophyDto'

export class RenderComponentMintedTrophyStrategy implements RenderComponentStrategyInterface {
  doesFit (product: ComponentProductDto): boolean {
    return product.type === 'trophy' && product.mintStatus === 'minted'
  }

  toComponent (product: ComponentProductDto): ReactElement {
    return (
      <MemoryAddableTrophyCard
        trophyDto={ product as ComponentTrophyDto }
        key={ product.id }
      />
    )
  }
}
